// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#serviceStatusStrip.text-caption[data-v-23eb929b] {\n  letter-spacing: normal !important;\n}\n.highlight-auto[data-v-23eb929b] {\n  color: #2d9cdb;\n  text-decoration: underline;\n}\n.v-tooltip__content[data-v-23eb929b] {\n  pointer-events: initial;\n}", ""]);
// Exports
module.exports = exports;
